import { render, staticRenderFns } from "./RelateOrder.vue?vue&type=template&id=6b015bec&"
import script from "./RelateOrder.vue?vue&type=script&lang=js&"
export * from "./RelateOrder.vue?vue&type=script&lang=js&"
import style0 from "./RelateOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports